/** Standard subscription bullets — Settings, paywall, onboarding purchase. */
export const PREMIUM_BENEFIT_KEYS = [
    "native.paywall.benefit4x4MediumHard",
    "native.settings.benefit6x6Hard",
    "native.paywall.benefitLibrary",
    "native.paywall.benefitProgress",
];

export const PREMIUM_BENEFIT_DEFAULTS = {
    "native.paywall.benefit4x4MediumHard": "Unlock 4×4 Medium & Hard puzzles",
    "native.settings.benefit6x6Hard": "Unlock 6×6 all difficulty puzzles",
    "native.paywall.benefitLibrary": "Browse a massive puzzle library",
    "native.paywall.benefitProgress": "Save progress across devices",
};

/** @param {(key: string, opts?: { defaultValue?: string }) => string} t */
export function getPremiumBenefitLines(t) {
    return PREMIUM_BENEFIT_KEYS.map((key) =>
        t(key, { defaultValue: PREMIUM_BENEFIT_DEFAULTS[key] || key })
    );
}
